unit UserType;
{

/* Initail. */

}
interface

uses
  JS,
  PersonalDataType;

type
  TUserType = class
  private
    fUserKey: String;
    fLoginName: String;
    fPersonalData: TPersonalDataType;
    fLoggedIn: Boolean;
    fActive: Boolean;
  public
    property UserKey: String read fUserKey;
    property LoginName: String read fLoginName;
    property PersonalData: TPersonalDataType read fPersonalData;
    property LoggedIn: Boolean read fLoggedIn;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TUserType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fUserKey := String(JSObject_Type['userKey']);
    fLoginName := String(JSObject_Type['loginName']);
    fPersonalData := TPersonalDataType.Create(TJSJSON.stringify(JSObject_Type['personalData']));
    fLoggedIn := (String(JSObject_Type['loggedIn']) = 'true');
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
